import { DateToItsTimezone } from '@core/constants/time.defaults';
import { offsetSteps } from '@dashboard/components/map-timeline/timeline.service';
import { IDashboardUiState } from '@dashboard/dashboard-store/dashboard.state';
import moment from 'moment';

const date = undefined;

export const InitalFromDate = DateToItsTimezone(
  moment(date).subtract(2, 'd'),
  0
);
export const InitialToDate = DateToItsTimezone(
  moment(date).subtract(0, 'd'),
  0
);
export const DefaultFromDateRouteParam = (toDate: string) =>
  moment.parseZone(toDate).subtract(2, 'd').format('YYYY-MM-DDTHH:mm:ss');

export const DefaultToDateRouteParam = () =>
  moment().utc().format('YYYY-MM-DDTHH:mm:ss');
// const date = '2025-10-01T00:00:00Z';
export const DashboardUiState: IDashboardUiState = {
  selectedVessel: '',
  realtimeIsActive: true,
  fromDate: InitalFromDate,
  toDate: InitialToDate,
  timezone: 0,
  tooltipTemplate: '',
  sideBar: {
    isSidebarHeadExpanded: true,
    sidebarLoading: false,
    infoExpandedLoading: false,
  },
  aggregation: {
    size: 30,
    step: 'm',
  },
  offsetStep: offsetSteps['d'],
  vessels: {},
  rightBar: {
    view: 'vesselSearch',
    loading: false,
  },
  map: {
    baseLayers: { label: '', layers: [], icon: '' },
    layers: { label: '', layers: [], icon: '' },
    windLayers: {
      loading: false,
      windyType: null,
    },
    selectedOverlayLayers: [],
    selectedBaseLayer: '0',
    zoom: 3,
    bounds: null,
    vessels: {
      loading: false,
      showName: false,
    },
    dms: {
      enabled: false,
      firstClick: null,
      secondClick: null,
    },
  },
  trace: {
    loading: false,
    traceConfig: [],
    activeConfigId: 1,
  },
  errors: {
    charts: {
      clustering: {
        msg: null,
      },
      queryData: {
        msg: null,
      },
    },
  },
};
